import URLEndPointBE from './URLEndPointBE'

function DisplayFoto(props: any) {
    const fotoEndpoint = URLEndPointBE+`/foto`
    return (<span>
        <img src={fotoEndpoint+"/"+props.foto.fotoId} alt={"foto"} width={"120"} height={"120"} style={{float:"left", marginLeft:"2px", marginRight:"2px"}}/>
        </span>
    )
}
export default DisplayFoto